'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m3.851 2.5 3.167 3.167L8.98 7.63l1.612 1.61 4.116 4.117 2.129 2.128L18.8 17.45l2.699 2.699-1.34 1.351-4.052-4.05H3.556V5.667h.77L2.5 3.84 3.851 2.5Zm17.649 3v12l-3.342-3.341a2.027 2.027 0 0 1 1.296-.475V9.59a2.045 2.045 0 0 1-2.045-2.045h-5.864L9.5 5.5h12ZM7.232 8.574c-.309.559-.875.955-1.543 1.013l-.17.007v3.93c1.036 0 1.884.8 1.959 1.816l.005.146h6.662l-1.064-1.065a2.946 2.946 0 0 1-3.596-3.327l.045-.223-2.298-2.297ZM12.5 8.5a3.344 3.344 0 0 1 3 3Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var CashOff = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.CashOff = CashOff;